import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { ClickLinkRedirectDirective } from './directives';
import { ccsHelpState } from '../../shared/helpers';
import { faChevronRight } from '../../shared/constants';
@Component({
  selector: 'app-ccs-help-item',
  imports: [
    MatListModule,
    MatButtonModule,
    FontAwesomeModule,
    ClickLinkRedirectDirective,
  ],
  template: `
    <mat-nav-list>
      @for (help of ccsHelpState.helpLinks(); track help.id) {
        <a mat-list-item [appClickLinkRedirect]="help.link">
          <span matListItemTitle>
            <span class="dot">•</span>
            {{ help.name }}
          </span>
          <span matListItemMeta>
            <fa-icon [icon]="faChevronRight" class="text-primary-700" />
          </span>
        </a>
      }
    </mat-nav-list>
  `,
  styleUrls: ['./ccs-help-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcsHelpItemComponent {
  protected readonly ccsHelpState = ccsHelpState();
  protected readonly faChevronRight = faChevronRight;
}
